// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cookie-toggle-row--WuqBV .cookie-toggle-row__info--uq7tj{max-width:680px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cookie-toggle-row": "cookie-toggle-row--WuqBV",
	"cookie-toggle-row__info": "cookie-toggle-row__info--uq7tj"
};
export default ___CSS_LOADER_EXPORT___;
